import { Redirect } from 'next';

import { BLOG, BLOG_ARTICLE, DASHBOARD, HOME, LOGIN, JOB_BOARD } from '@pflegia/ui/pflegia/constants/routes';

export * from '@pflegia/ui/pflegia/constants/routes';

export const CONTACT_PHONE_NUMBER = '+49 162 4791364';

export const RoutesRedirect = {
  FallbackFromProtectedPage: LOGIN,
  DefaultLoggedInPage: DASHBOARD,
};

export const workingHoursPerWeek = 40;
export const numberOfWorkDaysPerYear = 173;

// All Values for circle progress bar
export const size = 160;
export const strokeWidth = 25;
export const circleOneStroke = '#DCE9FF';
export const circleTwoStroke = '#0061FE';
export const center = size / 2;
export const radius = size / 2 - strokeWidth / 2;
export const circumference = 2 * Math.PI * radius;

export const DASHBOARD_REDIRECT: { redirect: Redirect } = { redirect: { destination: DASHBOARD, permanent: false } };
export const HOME_REDIRECT: { redirect: Redirect } = { redirect: { destination: HOME, permanent: false } };
export const JOB_BOARD_REDIRECT: { redirect: Redirect } = { redirect: { destination: JOB_BOARD, permanent: false } };

export const FACEBOOK_URL = 'https://www.facebook.com/Pflegia/';
export const PRAXIA_FACEBOOK_URL = 'https://www.facebook.com/people/Praxia/61557179145625/';
export const YOUTUBE_URL = 'https://www.youtube.com/channel/UCMdbuakr01UgNKK-0CiDIxg';
export const PRAXIA_YOUTUBE_URL = 'https://www.youtube.com/@praxia24';
export const INSTAGRAM_URL = 'https://www.instagram.com/pflegia/';
export const PRAXIA_INSTAGRAM_URL = 'https://www.instagram.com/praxia.de/';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/pflegia-ag';
export const PRAXIA_LINKEDIN_URL = 'https://www.linkedin.com/company/praxia-de/';
export const CUSTOMER_SERVICE_TELEPHONE = '+49 162 479 13 64';

const TRUSTPILOT_REVIEW_BASE_URL = 'https://de.trustpilot.com/review';
export const PFLEGIA_TRUSTPILOT_REVIEW_URL = `${TRUSTPILOT_REVIEW_BASE_URL}/pflegia.de`;
export const PRAXIA_TRUSTPILOT_REVIEW_URL = `${TRUSTPILOT_REVIEW_BASE_URL}/praxia.de`;
const TRUSTPILOT_FAQ_UTM_PARAMS = '?utm_campaign=faq_snippet&utm_medium=organic&utm_source=faq';
export const PFLEGIA_TRUSTPILOT_FAQ_URL = `${PFLEGIA_TRUSTPILOT_REVIEW_URL}${TRUSTPILOT_FAQ_UTM_PARAMS}`;
export const PRAXIA_TRUSTPILOT_FAQ_URL = `${PRAXIA_TRUSTPILOT_REVIEW_URL}${TRUSTPILOT_FAQ_UTM_PARAMS}`;
export const DIGITAL_PACT_BAVARIA_URL =
  'https://www.bpa.de/news-landesgruppen/bayern/news/digitalpakt-pflege-bayerns-weg-in-die-zukunft-der-pflege';
export const BAVARIA_URL = 'https://www.bayern.de/';
export const PACT_OF_CARE_BRANDENBURG_URL =
  'https://masgz.brandenburg.de/masgz/de/presse/pressemitteilungen/detail/~20-11-2025-pakt-fuer-pflege-2-0#';

export const OTHERS_VALUE = 'others';

export const INTERESTED_JOB_LINK = 'I.J.L';

export const BLOG_POSTS_PER_PAGE = 5;
export const BLOG_ARTICLES_MORE_LIMIT = 9;
export const PAGES_WITH_CUSTOM_TRACKING = [BLOG, BLOG_ARTICLE];
export const DEFAULT_REGISTERED_USER_COUNT = 181034;
export const DEFAULT_REGISTERED_USER_COUNT_PRAXIA = 30642;

/**
 * Intentional delay recommended by Segment to ensure all tracking events are sent.
 */
export const SEGMENT_SEND_DELAY = 500;

// Regular expression to validate email addresses.
// - Starts with one or more alphanumeric characters, dots, underscores, percent signs, pluses, or hyphens (local part).
// - Followed by the "@" symbol.
// - Followed by one or more alphanumeric characters, dots, or hyphens (domain name).
// - Followed by a literal dot (period) character.
// - Ends with two or more alphabetical characters for the top-level domain (TLD).
export const EMAIL_REGEX = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);

export const REDIRECT_REGEX = new RegExp(/^\//);

/** @deprecated Import from date-fns/constants instead */
export const MILLISECONDS_IN_A_SECOND = 1000;
/** @deprecated Import from date-fns/constants instead */
export const SECONDS_IN_A_DAY = 86400;
/** @deprecated Import from date-fns/constants instead */
export const MILLISECONDS_IN_A_DAY = SECONDS_IN_A_DAY * MILLISECONDS_IN_A_SECOND;

export const MONTHS_BEFORE_SALARY_EXPIRY = 6;

export const DEFAULT_IMAGE_QUALITY = 75;

// Query Params
export const TRANSPARENT_FUNNEL = 'transparent';
export const MULTIPOSTING_FUNNEL = 'multiposting';

export const INVITE_OPEN_SOURCE_EXPIRE_HOURS = 6;
